import { useEffect, useRef } from 'react';

/**
 * Hook that returns the previous value of the given parameter
 */
export const usePrevious = <T>(value: T) => {
    const ref = useRef<T>(undefined);

    useEffect(() => {
        ref.current = value;
    });

    return ref.current as T;
};
